var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnidefFouramMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    rx: 14,
    fill: "#F7D132"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.335 29.333H36.0016V25.9997H39.335M32.6683 29.333H29.335V25.9997H32.6683M26.0016 29.333H22.6683V25.9997H26.0016M44.335 14.333H17.6683C16.7842 14.333 15.9364 14.6842 15.3113 15.3093C14.6862 15.9344 14.335 16.7823 14.335 17.6663V47.6663L21.0016 40.9997H44.335C45.219 40.9997 46.0669 40.6485 46.692 40.0234C47.3171 39.3982 47.6683 38.5504 47.6683 37.6663V17.6663C47.6683 16.7823 47.3171 15.9344 46.692 15.3093C46.0669 14.6842 45.219 14.333 44.335 14.333Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnidefFouramMobile);
export default __webpack_public_path__ + "static/media/unidef-fouram-mobile.01206018738b121d8ef2cb0ae811615c.svg";
export { ForwardRef as ReactComponent };